import type { ReactElement } from 'react';
import { Stack } from '@mantine/core';
import PageHeaderComponent from '@/design/PageHeaderComponent';
import AuditLogView from '@/features/audit/AuditLogView';

/**
 * Platform-wide audit view (SAAS-34) — the cross-tenant lens on the audit trail
 * for support and compliance. Operator-gated by the surrounding OperatorLayout.
 */
export default function OperatorAuditPage(): ReactElement {
    return (
        <Stack gap="md">
            <PageHeaderComponent
                title="Audit log"
                subtitle="Every privileged action across all tenants — provisioning, lifecycle, access and configuration changes."
            />
            <AuditLogView scope="operator" />
        </Stack>
    );
}
